import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import StickyDealBar from "@/components/StickyDealBar";
import Home from "@/pages/Home";
import TheGame from "@/pages/TheGame";
import ThePlayers from "@/pages/ThePlayers";
import HouseRules from "@/pages/HouseRules";
import FirstGame from "@/pages/FirstGame";
import DealMeIn from "@/pages/DealMeIn";
import Lounges from "@/pages/Lounges";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return undefined;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <SiteHeader />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/the-game" element={<TheGame />} />
            <Route path="/the-players" element={<ThePlayers />} />
            <Route path="/house-rules" element={<HouseRules />} />
            <Route path="/first-game" element={<FirstGame />} />
            <Route path="/deal-me-in" element={<DealMeIn />} />
            <Route path="/lounges" element={<Lounges />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <SiteFooter />
        <StickyDealBar />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
